
var menuMaker = require('./client-lib/page-integration')

menuMaker('.menu-editor-page-seg')